var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20759_267676)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20759_267676)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 5.82227C8.79519 5.82227 8.5999 5.82227 9.4399 5.82227H10.8739C11.2749 5.82227 11.5999 6.14329 11.5999 6.5393V10.083C11.5999 10.479 11.2749 10.8 10.8739 10.8H5.1259C4.72494 10.8 4.3999 10.479 4.3999 10.083V6.5393C4.3999 6.14329 4.72494 5.82227 5.1259 5.82227H6.5599C7.5999 5.82227 7.20461 5.82227 7.9999 5.82227ZM10.7908 6.76571L9.40629 7.78407C8.57216 8.3976 7.42814 8.39375 6.59825 7.77464L5.24682 6.76644C5.16749 6.70726 5.05461 6.72279 4.9947 6.80114C4.93478 6.87949 4.95051 6.99097 5.02984 7.05015L6.38127 8.05835C7.33883 8.77272 8.65886 8.77715 9.62132 8.06923L11.0058 7.05087C11.0856 6.99223 11.1021 6.88085 11.0427 6.80211C10.9833 6.72336 10.8705 6.70707 10.7908 6.76571Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20759_267676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20759_267676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.2,
    height: 5.2,
    fill: "white",
    transform: "translate(4.3999 5.59961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotification);
export default __webpack_public_path__ + "static/media/mobile-notification.72d1babe7cdd685bb72631d1f2942cde.svg";
export { ForwardRef as ReactComponent };